import { Component, effect, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SharedService } from 'src/app/common/services/shared.service';
import { ReportService } from 'src/app/reports/services/report.service';
import { ReportMapService } from 'src/app/reports/services/report-map.service';
import { debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { layerConstant } from 'src/app/common/constants/layer-constant';
import { ActivatedRoute } from '@angular/router';
interface ClusterOption {
  value: string;
  label: any,
  default: boolean
}
@Component({
  selector: 'app-map-layers',
  templateUrl: './map-layers.component.html',
  styleUrls: ['./map-layers.component.scss']
})
export class MapLayersComponent implements OnInit, OnDestroy{
  panelOpenState = false;
  basemap_select: string = this.mapService.mapLayer_current();
  public legendLayerGroup: any = [];
  public defultLegendLayerGroup: any = [];
  public layerData: any = [];
  current_lang: any = 'en';
  current_lang_id: number = 1;
  mapLayers: any[] = [];
  defultMapLayers: any[] = [];
  studyName: any;
  isParcelActive: boolean = false;
  isClusterActive: boolean = true;
  isClusterDisabled: boolean = false;
  selectedBasemapValue: boolean = false;
  legendChange$ = new Subject<any>();
  private clusterToggle$ = new Subject<any>();
  private destroy$ = new Subject<void>();
  @Input('mapLayertoggle') mapLayertoggle:boolean=false;
  @Input('is_avg_transaction') is_avg_transaction:boolean=false;
  @Input('is_transaction_table') is_transaction_table:boolean=false;
  @Input('is_rental_table') is_rental_table:boolean=false;
  @Input('mapZoom') mapZoom:any;
  @ViewChild('customLayerController', {static: true}) customLayerController!:ElementRef;
  rentalClusters:ClusterOption[]=layerConstant.rentalClusters;
  selectedCluster:string='';
  selectedClusterDefault:any='';

  constructor(public reportService: ReportService, private mapService: ReportMapService, private sharedService: SharedService, private activatedRoute: ActivatedRoute
  ) {
    this.selectedClusterDefault=layerConstant.rentalClusters.find(r=>r.default) || {value:''};
    this.selectedCluster=this.selectedClusterDefault?.value;
    this.sharedService.language$.subscribe((lang) => {
      this.current_lang_id = lang == 'ar'?2:1;
      this.current_lang = lang;
    });
    effect(()=> this.basemap_select= this.mapService.mapLayer_current())
    this.activatedRoute.queryParams.subscribe((param: any) => {
      if(param.polygon){
        this.isClusterDisabled = true;
        if(this.selectedCluster == layerConstant.rentalClusters[0].value)this.clusterChange(layerConstant.rentalClusters[1]);
      }else{
        this.isClusterDisabled = false;
      }
    })
  }
  toggleCluster(event: Event) { 
    const inputElement = event.target as HTMLInputElement;
    this.isClusterActive = inputElement.checked;
    this.clusterToggle$.next({flag:this.isClusterActive, value:''});
  }
  clusterChange(cluster: any) {
    this.selectedCluster = cluster.value;
    if (cluster.value === layerConstant.rentalClusters[1].value) {
      this.mapService.islumsumCluster$.set(cluster);
    } else {
      this.mapService.islumsumCluster$.set(cluster);
      this.isClusterActive = false;
    }
    if (cluster.value === 'none') {
      this.clusterToggle$.next({flag:false, value:cluster.value})
    } else {
      this.clusterToggle$.next({flag:true, value:cluster.value})
    }
}
  ngOnInit(): void {
    this.mapService.overlay_mapLayerEvent$.pipe(
      takeUntil(this.destroy$)
    ).subscribe((layers)=>{
      if(layers?.layer_name){
       let layer = this.mapLayers.find((r: any) => r.layer_name.includes(layers.layer_name) && !r.display)
        if(layer)this.selectedLayers(layer)
      }
    })

    this.clusterToggle$
      .pipe(
        debounceTime(200), 
        distinctUntilChanged((prev, curr) => {
          if (prev?.value == 'x' && curr.value === layerConstant.rentalClusters[1].value) {
            return true; 
          }
          return prev?.flag === curr?.flag && prev?.value === curr?.value;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe((item) => {
        this.mapService.toggleCluster$.next(item);
      });

    let initflag = true;
    this.legendChange$
    .pipe(debounceTime(300)) 
    .subscribe((legend) => {
      this.selectedLegend(legend); 
    });
    this.reportService.selectedReport$.pipe(
      debounceTime(500),
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      this.studyName = this.reportService?.selectedStudies?.study_name;
      // if(data?.type){
      // console.log('data?.type legend map layer initflag', data);
      if(data?.type == 'new_report') initflag = true;
        this.isClusterActive = true;
        let value = this.is_rental_table?layerConstant.rentalClusters[1].value:'x';
        // this.clusterToggle$.next({flag:true, value:'x'});
      // }
      if (data.flag && (initflag || data?.type)) {
        initflag = false;
        // let layer_data = this.reportService.getCurrentReport();
        let layer_data = this.reportService.setReportData();
        if (layer_data) {
          this.layerData = layer_data.layer;
          // if(!this.legendLayerGroup?.length){
            const legendLayerGroup = layer_data.legend?.map((p:any) => {
              return {
                ...p,
                data: p.data.filter((item:any) => item.layer_status === true)
              };
            });
            // Create a deep copy of legendLayerGroup
            this.defultLegendLayerGroup = JSON.parse(JSON.stringify(legendLayerGroup));
            this.legendLayerGroup = legendLayerGroup;
          // }
          // Create a deep copy of legendLayerGroup
          this.defultMapLayers = layer_data.map_layer && JSON.parse(JSON.stringify(layer_data.map_layer));
          this.mapLayers = layer_data.map_layer;
          // Check if elements with overflowing content need a tooltip and update the `showToolTip` property accordingly.
          setTimeout(()=>{
            this.getLayerTooltip();
          })
        }
        this.resetLayer(false);
      }
    })
    this.mapService.overlay_mapLayer_selected.pipe(takeUntil(this.destroy$)).subscribe((layer: any) => {
      if(layer?.length){
        const target = this.mapLayers.find((r: any) => r.layer_name === layer[0]?.layer_name);
        if (target) {
          if(target.display) return;
          target.display = true;
        }
         this.selectedLayers(layer[0], true);
      }
    });
    

    this.mapService.mapLayerSwitcher.pipe(takeUntil(this.destroy$)).subscribe((layer:string)=>{
      if(layer && !this.selectedBasemapValue) {
          this.selectedBasemap(layer);
          this.basemap_select = layer;
      }
    })  
  }
  /**
   * This function is used to add condition to show tooltip when ellipses is added for overflow layer name.
   */
  getLayerTooltip(){
    let elements: NodeListOf<Element> = document.querySelectorAll('.maplayer-box');
    let layerStatusArr = this.mapLayers?.filter((x:any) => x.layer_status) || [];
    layerStatusArr.forEach((list, index) => {
      let element = elements[index] as HTMLElement;
      if (element) {
        // const lastChild = element.firstChild as HTMLElement;
        const scrollWidth = element.scrollWidth;
        const clientWidth = element.clientWidth;
        list['showToolTip'] = scrollWidth > clientWidth;
      }else{
        list['showToolTip'] = false;
      }
    });

     // Synchronize showToolTip in defultMapLayers
     this.defultMapLayers = this.defultMapLayers?.map((defaultLayer: any) => {
      const matchingLayer = this.mapLayers.find(
        (layer: any) => layer.layer_name === defaultLayer.layer_name
      );
      return {
        ...defaultLayer,
        showToolTip: matchingLayer ? matchingLayer.showToolTip : false,
      };
    });
  }
/**
 * Resets the map layers and legend to their default state.
 */
  resetLayer(isreset:boolean=true) {
    this.selectedCluster=this.selectedClusterDefault?.value;
    if(this.is_rental_table){
      this.mapService.islumsumCluster$.set(this.selectedClusterDefault);
    }
    this.isClusterActive = true;
    this.clusterToggle$.next({flag:true, value:this.selectedCluster});
    this.selectedBasemap('default');
    this.legendLayerGroup = JSON.parse(JSON.stringify(this.defultLegendLayerGroup));
    this.mapLayers = JSON.parse(JSON.stringify(this.defultMapLayers));
    this.mapService.legendToggle.next(false);
    this.getLayerTooltip();
    let selectedLegend = this.defultLegendLayerGroup.filter((r: any) => r.display == true)
    let selectedLayer = this.mapLayers.filter((r: any) => r.display == true)
    selectedLayer.push({isshowClicked:false});
    this.mapService.overlay_mapLayer.next(selectedLayer);
    
    if(isreset) {
      this.mapService.legendLayerGroup.next(selectedLegend);
    }
    this.isParcelActive = this.enabledisabelZoningCategory(this.mapLayers);
  }
  enabledisabelZoningCategory(activeMapLayers: any) {
    let val = activeMapLayers.find((r: any) => r.layer_name === layerConstant.parcel && r.display);
    return !!val;
  }
/**
 *
 * @returns
 * Checks if the reset layer functionality should be disabled.
 */
  resetLayerDisable(): boolean {
    return (
      (this.isClusterActive || this.selectedCluster === this.selectedClusterDefault?.value) && this.basemap_select === 'default' &&
      JSON.stringify(this.legendLayerGroup) === JSON.stringify(this.defultLegendLayerGroup) &&
      JSON.stringify(this.mapLayers) === JSON.stringify(this.defultMapLayers)
    );
  }
debouncedLegendChange(legend: any) {
  this.legendChange$.next(legend);
}
  selectedLegend(data: any) {
    if(this.reportService.getLockReport()){
      return;
    }
    //
    // if (!data.display) {
      data.display = !data.display;
      // this.legendLayerGroup = this.legendLayerGroup;
      // .map((r: any) => {
      //   if(r.display == true && data.legend_type  == r.legend_type){
      //     return r;
      //   } else {
      //     return {
      //       ...r,
      //       display: false
      //     }
      //   }
      // });
    this.mapService.currentLegendState.set(data)
      let selectedLegendCatZon = this.legendLayerGroup.filter((r: any) => r.display == true);
      this.mapService.legendLayerGroupList.next(this.legendLayerGroup);
      this.mapService.legendLayerGroup.next(selectedLegendCatZon);
      // this.mapService.legendToggle.next(true);
    // }
  }

  selectedBasemap(value: string, flag:boolean=false) {
    this.selectedBasemapValue = flag;
    if(value == this.mapService.mapLayer_current()) return;
    this.mapService.mapLayer_current.set(value)
    this.mapService.basemapLayer.next(value);
  }

  selectedLayers(value: any, flag:boolean=false) {
    if(this.reportService.getLockReport()){
      return;
    }
    if(!flag) value.display = !value.display;
    this.mapService.overlay_mapLayer_current.set(value)
    let layers = this.mapLayers.filter((r: any) => r.display == true)
    layers.push({isshowClicked:false});
    this.mapService.overlay_mapLayer.next(layers);
    this.isParcelActive = this.enabledisabelZoningCategory(layers);
  }

  onImgError(event: any) {
    event.target.src = "../../../../assets/images/map_layer_icons/Default.svg";
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
